"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStateRef = void 0;
const react_1 = require("react");
const useStateRef = defaultValue => {
  const [state, setState] = (0, react_1.useState)(defaultValue);
  const ref = (0, react_1.useRef)(state);
  const dispatch = (0, react_1.useCallback)(val => {
    ref.current = typeof val === "function" ? val(ref.current) : val;
    setState(ref.current);
  }, []);
  // Necessary to type here, (or technically recast), to mute
  // `dispatch` mismatching type error. It behaves the same as
  // returning a setter function, but assigning to `useCallback`
  // gives us some hard-to-debug type mismatch errors.
  return [state, dispatch, ref];
};
exports.useStateRef = useStateRef;